import GoodsTracking from "@/pages/Asus/GoodsTracking";
import GoodsTrackingMap from "@/pages/Asus/GoodsTrackingMap";
import Index from "@/pages/Asus/Index";
import Search from "@/pages/Asus/Search";
import Th from "@/pages/Asus/th/Index";
import ThOrder from "@/pages/Asus/th/Order";
import ThGoods from "@/pages/Asus/th/Goods";
import ThTrans from "@/pages/Asus/th/Trans";
import ThFiles from "@/pages/Asus/th/Files";
import Sh from "@/pages/Asus/sh/Index";
import ShOrder from "@/pages/Asus/sh/Order";
import ShGoods from "@/pages/Asus/sh/Goods";
import ShTrans from "@/pages/Asus/sh/Trans";
import ShFiles from "@/pages/Asus/sh/Files";
import Thd from "@/pages/Asus/Thd";
import Psd from "@/pages/Asus/Psd";
import Abnormal from "@/pages/Asus/Abnormal";

let router = [
  {
    path: "/Asus/goods_tracking",
    name: "goods_tracking",
    component: GoodsTracking,
    meta: {
      title: "货物跟踪",
      keepAlive: true,
      login: false // 是否需要登录
    }
  },
  {
    path: "/Asus/tracking_map",
    name: "tracking_map",
    component: GoodsTrackingMap,
    meta: {
      title: "运输轨迹",
      keepAlive: true,
      login: false // 是否需要登录
    }
  },
  {
    path: "/Asus/",
    name: "Index",
    component: Index,
    meta: {
      title: "TMS运输管理系统",
      keepAlive: true
    }
  },
  {
    path: "/Asus/thd",
    name: "thd",
    component: Thd,
    meta: {
      title: "提货单",
      role: [0]
    }
  },
  {
    path: "/Asus/psd",
    name: "psd",
    component: Psd,
    meta: {
      title: "送货单",
      role: [0]
    }
  },
  {
    path: "/Asus/search",
    name: "search",
    component: Search,
    meta: {
      title: "搜索"
    }
  },
  {
    path: "/Asus/th",
    name: "th",
    component: Th,
    meta: {
      title: "提货单"
    },
    children: [
      {
        path: "/Asus/th/order",
        name: "order",
        component: ThOrder,
        meta: {
          title: "提货单信息"
        }
      },
      {
        path: "/Asus/th/goods",
        name: "goods",
        component: ThGoods,
        meta: {
          title: "货物"
        }
      },
      {
        path: "/Asus/th/trans",
        name: "trans",
        component: ThTrans,
        meta: {
          title: "物流"
        }
      },
      {
        path: "/Asus/th/files",
        name: "files",
        component: ThFiles,
        meta: {
          title: "回单"
        }
      }
    ]
  },
  {
    path: "/Asus/sh",
    name: "sh",
    component: Sh,
    meta: {
      title: "送货单"
    },
    children: [
      {
        path: "/Asus/sh/order",
        name: "order",
        component: ShOrder,
        meta: {
          title: "送货单信息"
        }
      },
      {
        path: "/Asus/sh/goods",
        name: "goods",
        component: ShGoods,
        meta: {
          title: "货物"
        }
      },
      {
        path: "/Asus/sh/trans",
        name: "trans",
        component: ShTrans,
        meta: {
          title: "物流"
        }
      },
      {
        path: "/Asus/sh/files",
        name: "files",
        component: ShFiles,
        meta: {
          title: "回单"
        }
      }
    ]
  },
  {
    path: "/Asus/abnormal",
    name: "abnormal",
    component: Abnormal,
    meta: {
      title: "异常反馈",
      role: [0]
    }
  },
  {
    path: "/Asus/transfer",
    name: "transfer",
    component: () => import("@/pages/Asus/Transfer"),
    meta: {
      title: "中转",
      keepAlive: false,
      login: false
    }
  }
];
export default router;



// WEBPACK FOOTER //
// ./src/router/Asus.js